var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"#FBFCFB"}},[_c('Header'),_c('div',{staticClass:"banner"},[_vm._v("会员中心 优质服务")]),_c('el-container',[_c('el-main',{staticStyle:{"min-height":"800px","padding":"0 78px"}},[_c('router-view')],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }